<template>
  <div class="banner">
    <img :src="imgUrl" alt="banner" />
  </div>
</template>
<script>
export default {
  props: {
    imgUrl: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="less" scoped>
.banner {
  img {
    display: block;
    width: 100%;
  }
}
</style>
